import React, { useState } from 'react';
import { Calendar, Zap, TrendingUp, Info } from './icons';
import BaziInputForm from './BaziInputForm';
import BaziReadingView from './BaziReadingView';
import BAZI_TEXTS from './baziTexts';
import useBaziAnalysis from '../hooks/useBaziAnalysis';
import {
  formatTimezoneOffset,
  getDefaultTimezoneOffset
} from '../view-models/baziReadingModel';

export default function BaziAnalyzer({ language = 'vi' }) {
  const [birthDate, setBirthDate] = useState('1978-05-18');
  const [birthHour, setBirthHour] = useState(14);
  const [timezoneOffsetMinutes, setTimezoneOffsetMinutes] = useState(getDefaultTimezoneOffset);
  const [gender, setGender] = useState('male');

  const { bazi, isLoading, detailedReading } = useBaziAnalysis({
    birthDate,
    birthHour,
    timezoneOffsetMinutes,
    gender,
    language
  });

  const t = BAZI_TEXTS[language] || BAZI_TEXTS.vi;
  const timezoneLabel = formatTimezoneOffset(timezoneOffsetMinutes);
  const highlightDescription = typeof t.highlightDesc === 'function'
    ? t.highlightDesc(timezoneLabel)
    : t.highlightDesc;

  return (
    <section className="card bazi-module" data-testid="bazi-module">
      <div className="bazi-hero">
        <div>
          <p className="bazi-chip">{t.chip}</p>
          <h2 className="bazi-title">{t.title}</h2>
          <p className="bazi-subtitle">{t.subtitle}</p>
          <div className="bazi-meta">{t.meta}</div>
        </div>
        <div className="bazi-icons">
          <Calendar size={24} />
          <Zap size={24} />
          <TrendingUp size={24} />
          <Info size={24} />
        </div>
      </div>

      <BaziInputForm
        t={t}
        birthDate={birthDate}
        birthHour={birthHour}
        timezoneOffsetMinutes={timezoneOffsetMinutes}
        gender={gender}
        highlightDescription={highlightDescription}
        formatTimezoneOffset={formatTimezoneOffset}
        onBirthDateChange={setBirthDate}
        onBirthHourChange={setBirthHour}
        onTimezoneChange={setTimezoneOffsetMinutes}
        onGenderChange={setGender}
      />

      {!bazi && !isLoading && <p className="muted-text">{t.invalidDate}</p>}
      <BaziReadingView detailedReading={detailedReading} t={t} />
    </section>
  );
}
